/**
 * eslint-disable react/prop-types
 *
 * @format
 */

/** @format */

import {Box, CircularProgress, Flex} from '@chakra-ui/react';
import {Elements} from '@stripe/react-stripe-js';
import {PaymentIntent} from '@stripe/stripe-js';
import axios from 'axios';
import {useRouter} from 'next/router';
import {useEffect, useState} from 'react';
import Stripe from 'stripe';
import useUser from '../../../lib/useUser';
import {CheckoutPackage} from '../../pages/join-the-assc/join';
import Spacer from '../../patterns/Spacer';
import {getStripe} from '../../utils';
import {CheckoutForm} from './CheckoutForm';

type StripeAcceptPaymentProps = {
	selectedPackage: CheckoutPackage;
	// Define additional props here...
} & Record<string, any>;

function StripeAcceptPayment({
	selectedPackage,
	...rest
}: StripeAcceptPaymentProps) {
	const router = useRouter();
	const {user} = useUser();
	const [clientSecret, setClientSecret] = useState('');
	// prettier-ignore
	const [subscription, setSubscription] = useState<
	Stripe.Subscription | undefined
	>(null);
	const [paymentIntent, setPaymentIntent] = useState<PaymentIntent | undefined>(
		null,
	);
	const {activePromo, stripeReturnUrlSubDirectory} = rest;

	useEffect(() => {
		const createUserSubscription = async () => {
			if (!user?.id) {
				return;
			}

			// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
			const {data} = await axios.post('/api/stripe/create-subscription', {
				coupon: selectedPackage?.promo?.coupon?.id,
				cmsUserId: user.id,
				stripeProdIds: [
					...(selectedPackage?.package?.mainSubscription ?? []),

					...(selectedPackage?.package?.additionalSubscriptions ?? []),
				],
				subscriptionId: subscription?.id,
			});

			setClientSecret(data?.clientSecret);
			setPaymentIntent(data?.subscription?.latest_invoice.payment_intent);
			setSubscription(data?.subscription);
		};

		void createUserSubscription();

		return () => {
			setClientSecret('');
			setPaymentIntent(undefined);
			setSubscription(undefined);
		};
	}, [router.isReady]);

	return (
		<Box>
			{clientSecret ? (
				<Elements
					options={{
						clientSecret,
						appearance: {
							theme: 'stripe',
							variables: {
								colorPrimary: '#8dc53f',
								colorText: '#00312d',
							},
						}, // https://stripe.com/docs/elements/appearance-api
					}}
					stripe={getStripe()}>
					<CheckoutForm
						clientSecret={clientSecret}
						paymentIntent={paymentIntent}
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
						stripeReturnUrlSubDirectory={stripeReturnUrlSubDirectory}
					/>
				</Elements>
			) : (
				<Flex
					justifyContent={{base: 'center'}}
					flexDir='column'
					alignItems={'center'}>
					<Spacer />
					<CircularProgress
						isIndeterminate
						color='lime.500'
						size='100px'
						thickness='3px'
					/>
					<Spacer />
					<Box>Loading...</Box> <Spacer />
				</Flex>
			)}
		</Box>
	);
}

export default StripeAcceptPayment;
